<hp-header></hp-header>

<!--body-->
<main class="main">
    <ng-container *ngIf="(pageHeadingType$ | async) === typeOP">
        <section id="page-heading" *ngIf="showPageHeading$ | async">
            <hp-page-heading></hp-page-heading>
        </section>
        <router-outlet *ngIf="(pageHeadingType$ | async) != typeHP"></router-outlet>
    </ng-container>
    <ng-container *ngIf="(pageHeadingType$ | async) === typeHP">
        <section id="page-heading" *ngIf="showPageHeading$ | async">
            <hp-page-heading></hp-page-heading>
          </section>
        <router-outlet></router-outlet>
    </ng-container>

    <ng-container *ngIf="pageHeadingType$ | async as item">
        <ng-container *ngIf="item !== typeHP && item !== typeOP">
            <router-outlet></router-outlet>
        </ng-container>
    </ng-container>
</main>

<!--footer-->
<hp-footer></hp-footer>

<w-alert></w-alert>